<template>
  <div>
    <div
      v-if="
        $route.path.indexOf('_detail') === -1 &&
        $route.path.indexOf('_edit') === -1
      "
    >
      <el-row>
        <el-col :span="24">
          <el-button type="primary" @click="toAdd()" size="mini"
            >新增+</el-button
          >
        </el-col>
      </el-row>
      <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="title" label="名称"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-tag size="mini" effect="plain" @click="edit(scope.row)"
              >编辑</el-tag
            >
            <el-tag size="mini" effect="plain" @click="del(scope.row.id,scope.$index)"
              >删除</el-tag
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="content-center content-top-padded">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="params.page"
          :page-sizes="[10, 20, 50]"
          :total="total_count"
          :page-size="params.pagesize"
        >
        </el-pagination>
      </div>
      <el-dialog title="新增*编辑" :visible.sync="dialogFormVisible">
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item label="名称" prop="title">
            <el-input v-model="form.title" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="经营品类" >
              <el-select v-model="form.merchant_category_ids" style="width:100%" multiple placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.category_id"
                :label="item.category_name"
                :value="item.category_id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <router-view></router-view>
  </div>
</template><script>
import { mapGetters } from "vuex";
import {
  getMerchantCategory,
  getMerchantCredentialTypes,
  delMerchantCredentialTypes,
  addMerchantCredentialTypes,
  editMerchantCredentialTypes,
} from "../../../api/merchant";

export default {
  components: {},
  data() {
    return {
      rules: {
        title: {
          required: true,
          message: "名称!",
          trigger: "blur",
        },
      },
      dialogFormVisible: false,
      total_count: 0,
      params: {
        page: 1,
        pagesize: 20,
      },
      options:[],
      form: { title: '',merchant_category_ids:'' },
      dataList: [],
      loading: false,
      id: "",
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
  },
  methods: {
    getCategory(){
      getMerchantCategory({ category_level: 2,page:1,pagesize:100 }).then((res) => {
        this.options = res.data.data.list;
      });
    },
    toAdd() {
      this.form=[];
      this.dialogFormVisible = true;
    },
    edit(row) {
      this.dialogFormVisible = true;
      this.form.title = row.title;
      this.form.merchant_category_ids = row.merchant_category_ids;
      this.id = row.id;
     
    },
    onSubmit(formName) {
      var submit = false;
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          console.log("error submit!!");
          return false;
        } else {
          submit = true;
        }
      });
      if (submit == false) {
        return;
      }
      var that = this;
      if (this.id) {
        if(this.form.merchant_category_ids == ''){
          this.form.merchant_category_ids=null
        }
        editMerchantCredentialTypes(this.id, this.form).then((res) => {
          if (res.status) {
            this.loading = false;
            this.$message({
              message: "修改成功",
              type: "success",
              duration: 2000,
            });
            this.dialogFormVisible = false;
            setTimeout(function () {
              that.params.page = 1;
              that.getDataList();
            }, 1000);
          } else {
            this.$message.error("修改失败!");
            return false;
          }
        });
      } else {
        addMerchantCredentialTypes(this.form).then((res) => {
          if (res.status) {
            this.loading = false;
            this.$message({
              message: "保存成功",
              type: "success",
              duration: 2000,
            });
            this.dialogFormVisible = false;
            setTimeout(function () {
               that.params.page = 1;
              that.getDataList();
            }, 1000);
          } else {
            this.$message.error("保存失败!");
            return false;
          }
        });
      }
    },
    del(id, index) {
      var that = this;
      this.$confirm("确定要删除该商品？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delMerchantCredentialTypes(id).then((res) => {
              if (res.status) {
                this.$message({
                  message: "已删除",
                  type: "success",
                  duration: 2000,
                });
                setTimeout(function () {
                  that.dataList.splice(index, 1);
                }, 1000);
              }
            });
          }
          done();
        },
      });
    },
    getDataList() {
      this.loading = true;
      getMerchantCredentialTypes(this.params)
        .then((response) => {
          this.dataList = response.data.data.list;
          this.total_count = response.data.data.total_count;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "获取列表信息出错",
          });
        });
    },
    handleCurrentChange(page_num) {
      this.params.page = page_num;
      this.getDataList();
    },
    searchData() {
      this.params.page = 1;
      this.getDataList();
    },
    handleSizeChange(pageSize) {
      this.params.page = 1;
      this.params.pagesize = pageSize;
      this.getDataList();
    },
  },
  mounted() {
    this.getDataList();
     this.getCategory();
  },
};
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  img {
    width: 90%;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 10px;
  img {
    width: 90%;
  }
}
.row-bg {
  padding: 10px 20px;
  background-color: #f9fafc;
}
.service-label .el-checkbox:first-child {
  margin-left: 15px;
}
.service-label .el-input:first-child {
  margin-left: 15px;
}
.grid-detail {
  max-height: 300px;
  overflow-y: scroll;
  margin-bottom: 20px;
}
.el-carousel {
  width: 375px;
}
.grid-detail {
  table,
  .detail-content-wrap,
  .detail-content-item {
    width: 100% !important;
  }
  img {
    width: 100%;
  }
}
.grid-attribute {
  table {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// list.vue?348ca2ca